import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import PaymentResult from "@/pages/PaymentResult";
import Paywall from "@/components/Paywall";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

function Gate() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user === false) return <Auth />;
  if (!user.onboarded) return <Onboarding />;
  return <Dashboard />;
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/payment/success" element={<PaymentResult status="success" />} />
                <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
                <Route path="*" element={<Gate />} />
              </Routes>
              <Paywall />
            </BrowserRouter>
            <Toaster position="top-center" theme="dark" richColors />
          </SubscriptionProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
